import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/politicas/getsemplice-motorista')({
  head: () => ({
    meta: [{ title: 'Política de Privacidade - GetSemplice Motorista' }],
  }),
  component: () => (
    <div className="flex flex-col gap-2 p-4">
      <section>
        <h1 className="scroll-m-20 pb-2 text-3xl font-semibold tracking-tight first:mt-0">
          Política de Privacidade para o Aplicativo GetSemplice Motorista
        </h1>
        <p>
          A sua privacidade é importante para nós. Esta Política de Privacidade
          descreve como coletamos, usamos e protegemos as informações fornecidas
          por você ao utilizar o aplicativo GetSemplice Motorista.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Informações Coletadas
        </h3>
        <p>
          O aplicativo GetSemplice Motorista coleta e utiliza dados para
          oferecer os serviços de controle e execução de rotas de transporte de
          passageiros. Os tipos de dados coletados incluem:
        </p>

        <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
          <li>
            Localização: Coletamos dados de localização em tempo real para
            monitorar a execução das rotas. A coleta pode ocorrer mesmo quando o
            aplicativo está em segundo plano, desde que autorizado pelo usuário.
          </li>
          <li>
            Informações sobre o Dispositivo: Podemos coletar informações básicas
            sobre o dispositivo, como modelo e versão do sistema operacional,
            para melhorar a funcionalidade do aplicativo.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Como Usamos Suas Informações
        </h3>

        <p>
          Os dados coletados são utilizados exclusivamente para os seguintes
          fins:
        </p>

        <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
          <li>Planejamento, controle e execução de rotas.</li>
          <li>
            Garantia de precisão no acompanhamento das viagens realizadas.
          </li>
          <li>Melhorias no desempenho e funcionalidades do aplicativo.</li>
          <li>Suporte técnico e resolução de problemas.</li>
        </ul>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Compartilhamento de Dados
        </h3>
        <p>
          As informações coletadas pelo aplicativo são compartilhadas apenas
          com:
        </p>

        <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
          <li>
            A empresa de transporte: Para fins de controle e gestão das
            operações de transporte.
          </li>
          <li>
            Fornecedores de serviços terceirizados: Quando necessário para
            oferecer suporte técnico ou implementar funcionalidades específicas,
            sempre em conformidade com esta política.
          </li>
        </ul>

        <p>
          Não vendemos, alugamos ou compartilhamos suas informações com
          terceiros para fins de marketing.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Permissões Necessárias
        </h3>
        <p>
          Para o funcionamento adequado do GetSemplice Motorista, é necessário
          que você conceda as seguintes permissões:
        </p>

        <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
          <li>
            Localização: Para monitorar sua posição durante a execução das
            rotas.
          </li>
          <li>
            Armazenamento: Para salvar dados temporários relacionados à execução
            das viagens.
          </li>
        </ul>

        <p>
          Você pode gerenciar as permissões a qualquer momento nas configurações
          do dispositivo.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Segurança dos Dados
        </h3>
        <p>
          Adotamos medidas técnicas e organizacionais para proteger suas
          informações contra acesso não autorizado, perda ou alteração. Os dados
          são transmitidos utilizando criptografia e armazenados em servidores
          seguros.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Retenção de Dados
        </h3>

        <p>
          Manteremos suas informações pelo período necessário para cumprir os
          objetivos descritos nesta política, salvo se for exigido por lei que
          os dados sejam armazenados por um período maior.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Direitos do Usuário
        </h3>
        <p>Você tem o direito de:</p>

        <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
          <li>
            Solicitar acesso, correção ou exclusão de seus dados pessoais.
          </li>
          <li>Restringir ou se opor ao processamento de seus dados.</li>
          <li>
            Retirar seu consentimento para o uso de dados de localização a
            qualquer momento, o que pode impactar a funcionalidade do
            aplicativo.
          </li>
        </ul>

        <p>
          Para exercer seus direitos, entre em contato pelo e-mail:
          <b>getsemplice@gmail.com</b>.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Alterações nesta Política
        </h3>

        <p>
          Esta Política de Privacidade pode ser atualizada periodicamente.
          Notificaremos você sobre alterações significativas por meio do próprio
          aplicativo ou por outros meios apropriados.
          <br />
          Ao continuar a utilizar o GetSemplice Motorista após a publicação de
          uma nova versão desta Política, você concorda com as alterações
          realizadas.
        </p>
      </section>

      <section>
        <h3 className="scroll-m-20 text-2xl font-semibold tracking-tight">
          Contato
        </h3>

        <p>
          Se você tiver dúvidas ou preocupações sobre esta Política de
          Privacidade, entre em contato conosco:
        </p>

        <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
          <li>
            E-mail: <b>getsemplice@gmail.com</b>
          </li>
        </ul>
      </section>

      <p>
        Última atualização: <b>29 de novembro de 2024</b>
      </p>
    </div>
  ),
});
